import { render, staticRenderFns } from "./alert-bar.vue?vue&type=template&id=281609f0&scoped=true"
import script from "./alert-bar.vue?vue&type=script&lang=js"
export * from "./alert-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281609f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2054317640/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281609f0')) {
      api.createRecord('281609f0', component.options)
    } else {
      api.reload('281609f0', component.options)
    }
    module.hot.accept("./alert-bar.vue?vue&type=template&id=281609f0&scoped=true", function () {
      api.rerender('281609f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/alert-bar.vue"
export default component.exports